import React from "react";

const ModelViewVleresimGjinor2 = ({ tableContent }) => {
  if (!tableContent || tableContent.length === 0) {
    return <p>Nuk ka të dhëna për t'u shfaqur.</p>;
  }

  return (
    <div style={{ overflowX: "auto" }}>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          textAlign: "center",
          fontFamily: "Arial, sans-serif",
        }}
      >
        <thead>
          <tr>
            <th style={headerStyle} colSpan="2">
              Moderatorët
            </th>
            <th style={headerStyle} rowSpan={2}>
              Televizioni
            </th>
            <th style={headerStyle} colSpan="2">
              Të ftuarit
            </th>
          </tr>
          <tr>
            <th style={{ ...subHeaderStyle, backgroundColor: "#bbdefb" }}>
              Meshkuj
            </th>
            <th style={{ ...subHeaderStyle, backgroundColor: "#f8bbd0" }}>
              Femra
            </th>
            <th style={{ ...subHeaderStyle, backgroundColor: "#bbdefb" }}>
              Meshkuj
            </th>
            <th style={{ ...subHeaderStyle, backgroundColor: "#f8bbd0" }}>
              Femra
            </th>
          </tr>
        </thead>
        <tbody>
          {tableContent.map((row, index) => {
            // Llogarit gjithsej moderatorë dhe gjithsej të ftuar
            const totalModeratore =
              parseInt(row["Nr. moderatorëve meshkuj"] || 0) +
              parseInt(row["Nr. moderatorëve Femra"] || 0);
            const totalFtuar =
              parseInt(row["Nr. të ftuarve Meshkuj"] || 0) +
              parseInt(row["Nr. të ftuarve Femra"] || 0);

            // Llogarit përqindjet
            const percModMeshkuj =
              totalModeratore > 0
                ? (
                    (parseInt(row["Nr. moderatorëve meshkuj"] || 0) /
                      totalModeratore) *
                    100
                  ).toFixed(1)
                : "0.0";
            const percModFemra =
              totalModeratore > 0
                ? (
                    (parseInt(row["Nr. moderatorëve Femra"] || 0) /
                      totalModeratore) *
                    100
                  ).toFixed(1)
                : "0.0";

            const percFtuarMeshkuj =
              totalFtuar > 0
                ? (
                    (parseInt(row["Nr. të ftuarve Meshkuj"] || 0) /
                      totalFtuar) *
                    100
                  ).toFixed(1)
                : "0.0";
            const percFtuarFemra =
              totalFtuar > 0
                ? (
                    (parseInt(row["Nr. të ftuarve Femra"] || 0) / totalFtuar) *
                    100
                  ).toFixed(1)
                : "0.0";

            return (
              <tr key={index}>
                <td style={{ ...cellStyle, backgroundColor: "#bbdefb" }}>
                  {percModMeshkuj}%
                </td>
                <td style={{ ...cellStyle, backgroundColor: "#f8bbd0" }}>
                  {percModFemra}%
                </td>
                <td style={cellStyle}>{row["Nr. Subjekti"]}</td>
                <td style={{ ...cellStyle, backgroundColor: "#bbdefb" }}>
                  {percFtuarMeshkuj}%
                </td>
                <td style={{ ...cellStyle, backgroundColor: "#f8bbd0" }}>
                  {percFtuarFemra}%
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

// Stilet
const headerStyle = {
  color: "black",
  padding: "8px",
  border: "1px solid #ddd",
};

const subHeaderStyle = {
  backgroundColor: "white",
  color: "black",
  padding: "8px",
  border: "1px solid #ddd",
};

const cellStyle = {
  padding: "8px",
  border: "1px solid #ddd",
};

export default ModelViewVleresimGjinor2;
